import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const CalendarContext = createContext(null);

const MeetingLayout = () => {
  const [events, setEvents] = useState({});
  const [activeWeeks, setActiveWeeks] = useState();
  const [showCreateEventFormModal, setShowCreateEventFormModal] =
    useState(false);

  return (
    <CalendarContext.Provider
      value={{
        activeWeeks,
        setActiveWeeks,
        events,
        setEvents,
        showCreateEventFormModal,
        setShowCreateEventFormModal,
      }}
    >
      <div className="flex flex-col flex-1 rounded-lg bg-white w-full flex-grow p-4">
        <Outlet />
      </div>
    </CalendarContext.Provider>
  );
};

export { CalendarContext };

export default MeetingLayout;
